var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot"},[_c('Condtion',{attrs:{"tableWidth":"auto","productList":_vm.productList},on:{"handleCurrentChange":_vm.handleCurrentChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }